$(document).ready(function () {
  $(document).on('click', '#see-all', function (e) {
    e.preventDefault();
    $('.reviews li').each(function(i, element) {
      $(element).show();
    });
    $('#see-all').hide();
  });
});
